import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  IconButton,
  Typography,
} from "@mui/material"
import { CloseOutlined, WarningOutlined } from "@mui-symbols-material/w300"
import type { FC } from "react"

import { Button } from "@/components/common/Button"

interface NoSalesSubscribersModalProps {
  isSendingToSelf: boolean
  isDownloading: boolean
  onCancel: () => void
  onSendToSelf: () => void
  onDownload: () => void
}

export const NoSalesSubscribersModal: FC<NoSalesSubscribersModalProps> = ({
  isSendingToSelf,
  isDownloading,
  onCancel,
  onSendToSelf,
  onDownload,
}) => {
  const isLoading = isSendingToSelf || isDownloading

  return (
    <Dialog open fullWidth onClose={onCancel} data-testid='sales.new-request-dialog.no-subscribers-modal'>
      <IconButton
        aria-label='close'
        disabled={isLoading}
        onClick={onCancel}
        className='absolute right-4 top-4 text-primary'
      >
        <CloseOutlined />
      </IconButton>
      <Divider />
      <DialogContent classes={{ root: "p-10 flex flex-col gap-6" }}>
        <Box className='flex justify-center'>
          <WarningOutlined color='error' fontSize='large' />
        </Box>
        <Typography color='primary' variant='h5' align='center'>
          There are no contacts subscribed to receive quotes
        </Typography>
        <Typography color='textSecondary' variant='body1' align='center'>
          However, you can send the quote to yourself or download it and send it manually.
        </Typography>
      </DialogContent>
      <DialogActions className='justify-between px-10 pb-10'>
        <Button
          appearance='outlined'
          disabled={isLoading}
          onClick={onCancel}
          data-testid='sales.new-request-dialog.no-subscribers-modal.cancel-button'
        >
          Cancel
        </Button>
        <Button
          appearance='text'
          disabled={isLoading}
          onClick={onSendToSelf}
          endIcon={
            isSendingToSelf ? (
              <Box className='flex items-center'>
                <CircularProgress size={16} />
              </Box>
            ) : undefined
          }
          data-testid='sales.new-request-dialog.no-subscribers-modal.send-to-myself-button'
        >
          Send To Myself
        </Button>
        <Button
          appearance='contained'
          disabled={isLoading}
          onClick={onDownload}
          endIcon={
            isDownloading ? (
              <Box className='flex items-center'>
                <CircularProgress size={16} />
              </Box>
            ) : undefined
          }
          data-testid='sales.new-request-dialog.no-subscribers-modal.download-quote-button'
        >
          Download Quote
        </Button>
      </DialogActions>
    </Dialog>
  )
}
